import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { FilterUtils } from '../../../shared/utils/filterutils';
import { Router } from '@angular/router';
import { AppService } from 'src/app/modules/shared/services/geral/app.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-feito-conferido',
  templateUrl: './feito-conferido.component.html',
  styleUrls: ['./feito-conferido.component.css']
})
export class FeitoConferidoComponent implements OnInit {

  constructor(public svc: AppService, private router: Router, private tl: TranslateService) { }

  public eventos_processo_selecionado: any[] = [];
  public processos: any[];
  public cols: any[];
  public progresso: number;
  public progressoLabel: number;
  public progressoTimeout: any;
  public slide_cor: string = "";
  public checkTipoFiltroPerc: boolean = false;
  public tb_vazio: boolean = false;
  public spinFeito = true;

  public sbAbrirModal(event: Event): void {
    try {
      var id = $(event.target).attr("data-modal");
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  };

  public sbAbrirModalEvento(event: Event): void {
    try {
      let processos = [];
      this.processos.forEach((item) => {
        if (item.fl) {
          processos.push(item);
        }
      });

      if (processos.length == 0) {
        this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("feito_conferido_tabela.mensagens.selecione_processo"));
      } else {
        var id = $(event.target).attr("data-modal");
        this.svc.sbAbrirModal(id);
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  };

  public sbAbrirModalAndamento(event: Event, data): void {
    try {
      this.eventos_processo_selecionado = data;
      var id = $(event.target).attr("data-modal");
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  };

  public eventoFeitoConferido(evento: boolean): void {
    try {
      let processos = [];
      this.processos.forEach((item) => {
        if (item.fl) {
          processos.push(item);
        }
      });

      this.svc.InserirFeitoConferido({
        id_poder_cliente: processos[0].id_poder_cliente,
        ind_aprova: evento
      });
      this.svc.FeitoConferidoIncluido().subscribe((resp) => {
         if (resp != null) {
          this.svc.sbFecharModal("modalCancelar");
          this.svc.sbFecharModal("modalConfirma");
          if (evento){
            this.svc.sbExibirAlerta("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("feito_conferido_tabela.mensagens.acao_efetuada"));
          } else {
            this.svc.sbExibirAlerta("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("feito_conferido_tabela.mensagens.acao_reprovada"));
          }
          this.carregarProcessos();
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  };

  public checkAll(event) {
    this.processos.forEach((item, index) => {
      this.processos[index].fl = event.target.checked;
    });
  }

  public sbRetornarFiltros(lista: any[], column: string): any {
    var retorno = [];

    if (lista) {
      for (let i = 0; i < lista.length; i++) {
        retorno.push(lista[i][column]);
      }

      retorno = retorno.filter(function (value, index) { return retorno.indexOf(value) == index });

      for (let i = 0; i < retorno.length; i++) {
        retorno[i] = { label: retorno[i], value: retorno[i] }
      }
    }

    return retorno;
  }

  public sbFiltrarPercentual(dt): void {
    if (this.progresso) {
      if (this.progressoTimeout) {
        clearTimeout(this.progressoTimeout);
      }

      if (this.progresso == 101) {
        this.slide_cor = "slider-verde";
      } else if (this.progresso < 101 && this.progresso > 66) {
        this.slide_cor = "slider-azul";
      } else if (this.progresso <= 66 && this.progresso > 33) {
        this.slide_cor = "slider-amarela";
      } else if (this.progresso <= 33 && this.progresso > 0) {
        this.slide_cor = "slider-vermelha";
      } else {
        this.slide_cor = "";
      }

      this.progressoLabel = this.progresso - 1;

      this.progressoTimeout = setTimeout(() => {
        if (this.checkTipoFiltroPerc)
          dt.filter(this.progresso - 1, 'percentual_andamento', 'equals');
        else
          dt.filter(this.progresso, 'percentual_andamento', 'lt');
      }, 250);
    }
  }

  public sbCarregarIdioma() {
    this.cols = [
      { type: 'checkbox', filter: true, filter_type: 'multi-select', header: '', field: 'fl', size: '3%' },
      { type: 'text-duplo', filter: true, filter_type: 'multi-select', header: this.tl.instant("conferido_tabela.cliente"), field: 'nome_cliente', size: '27%', coluna_aux: 'documento' },
      { type: 'hide', filter: false, filter_type: 'multi-select', header: '', field: 'documento_cliente', size: '0%' },
      { type: 'text-duplo', filter: true, filter_type: 'multi-select', header: this.tl.instant("conferido_tabela.processo"), field: 'nome_processo', size: '20%', coluna_aux: 'nome_contrato' },
      { type: 'hide', filter: false, filter_type: 'multi-select', header: '', field: 'numero_contrato', size: '0%' },
      { type: 'barra-progresso', filter: true, filter_type: 'slide', header: this.tl.instant("conferido_tabela.percentual"), field: 'percentual_andamento', size: '11%' },
      { type: 'text', filter: true, filter_type: 'data', header: this.tl.instant("conferido_tabela.data"), field: 'data_ult_evento', size: '12%' },
      { type: 'acao-text', filter: true, filter_type: 'multi-select', header: this.tl.instant("conferido_tabela.acao"), field: 'tipo_solicitacao', size: '15%' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("conferido_tabela.usuario"), field: 'cd_login_solicitante', size: '11%' }
    ];
  }

  public carregarProcessos() {
    try {
      //Carrega os Dados da Tabela Processos
      this.spinFeito = true;
      this.svc.FeitoConferidoPesquisar();
      this.svc.CadastroFeitoConferido().subscribe((resp) => {
        if (resp == false) this.spinFeito = false;
        else if (resp != null) {
          this.spinFeito = false;
          if (resp.processos.length == 0) this.tb_vazio = true;
          for (let i = 0; i < resp.processos.length; i++) {
            resp.processos[i].fl = false;
          }
          this.processos = resp.processos;
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  ngOnInit() {
    try {
      this.carregarProcessos();

      //É chamado sempre que o Idioma for Mudado
      this.svc.sbGetTraducaoAuto("monitor_tabela").subscribe((resp) => {
        this.sbCarregarIdioma();
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

}
